import styled from "styled-components";

export const CardContainer = styled.div`
  background-color: white;
  width: 100%;
  overflow: hidden;
  max-height: 750px;
  border-radius: 18px;
  box-shadow: 0px 2.79451px 3.79451px rgba(0, 0, 0, 0.15);
  font-family: "Inter", sans-serif;
  margin-bottom: 2rem;
  @media (max-width: 1550px) {
    width: 100%;
  }

  @media (max-width: 1300px) {
    width: 100%;
  }
`;

export const OrgInformation = styled.div`
  max-height: 200px;
  padding: 8px 25px;
`;

export const ProfilePicture = styled.img`
  width: 35px;
  border-radius: 50%;
  padding: 0.8% 0 0.5% 0;
  background-color: white;
  vertical-align: center;
  margin-right: 0.8%;

  @media (max-width: 950px) {
    width: 34px;
  }
`;

export const NameAndDate = styled.div`
  display: inline-block;
  margin: 1% 0% 1% 0%;
  padding-left: 25px;

  @media (max-width: 750px) {
    width: 80%;
    margin: 1% 0% 2% 0%;
  }

  @media (max-width: 500px) {
    vertical-align: bottom;
  }
`;

export const OrganizationName = styled.h4`
  margin: 0px 0px 2px 0px;

  @media (max-width: 750px) {
    display: inline-block;
    margin-right: 1rem;
    margin-bottom: 0;
  }

  @media (max-width: 375px) {
    font-size: 1.25rem;
  }
`;

export const TimePosted = styled.p`
  color: gray;
  font-size: 0.7rem;
  margin: 0;

  @media (max-width: 750px) {
    display: inline-block;
  }
`;

export const ActionsContent = styled.p`
  font-size: 0.7rem;
  margin: 0;

  @media (max-width: 750px) {
    display: inline-block;
  }
`;
export const MobileContent = styled.p`
  margin: 8px 0px;
  display: none;
  font-size: 0.8rem;

  @media (max-width: 750px) {
    font-size: 0.8rem;
    display: block;
  }

  @media (max-width: 500px) {
    display: none;
  }
`;

export const Content = styled.p`
  margin: 0 0 5px 0px;
  font-size: 0.8rem;
  text-align: justify;

  @media (max-width: 800px) {
    font-size: 0.8rem;
  }

  @media (max-width: 750px) {
    display: none;
  }

  @media (max-width: 500px) {
    display: block;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentPicture = styled.img`
  width: auto;
  height: 450px;
  max-width: 100%;
`;

export const BottomSection = styled.div``;

export const PostDetails = styled.div`
  color: #383838;
  border-bottom: 1.5px solid lightgray;
  display: flex;
  width: 95%;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
`;

export const Likes = styled.p`
  display: flex;
  align-items: center;
  margin-left: 1.5rem;
  margin: 5px 0;
  font-size: 0.8rem;
  position: relative;

  img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 0.5px solid white;
    z-index: 1;
  }

  img:nth-child(n+2) {
    margin-left: -10px;
  }

  img:nth-child(2) {
    z-index: 2;
  }

  img:nth-child(3) {
    z-index: 3;
  }

  span {
    margin-left: 10px;
  }
`;

export const CommentsAndShares = styled.div`
  display: flex;

  align-items: center;
  float: right;
  margin-right: 2.5rem;
  margin: 5px 0;

  font-size: 0.8rem;

  @media (max-width: 750px) {
    margin-right: 1rem;
    font-size: 0.8rem;
  }

  @media (max-width: 550px) {
    font-size: 0.8rem;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  @media (max-width: 375px) {
    float: none;
    margin-left: 2rem;
  }
`;

export const PostActions = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 10px;
  width: 80%;
  margin: auto;
`;

export const PostActionButton = styled.button.attrs<PostActionButtonProps>(
  ({ isLiked }) => ({
    'data-isliked': isLiked,
  })
)<PostActionButtonProps>`

  flex: 1;
  background: none;
  border: none;
  align-items: center;
  display: inline-flex;
  justify-content: left;
  padding: 0.3rem;
  font-size: 0.85rem;
  font-family: "Inter";
  text-align: left;
  margin: 0.5rem;

  img {
    width: 18px;
    height: 18px;
    margin-right: 0.5rem;
    filter: ${({ isLiked }) =>
      isLiked
        ? "invert(26%) sepia(74%) saturate(5370%) hue-rotate(312deg) brightness(88%) contrast(90%)"
        : "none"};
  }

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 1550px) {
    font-size: 0.8rem;
    img {
      width: 16px;
      height: 16px;
    }
  }

  @media (max-width: 750px) {
    font-size: 0.7rem;
    img {
      width: 14px;
      height: 14px;
    }
  }

  @media (max-width: 550px) {
    font-size: 0.65rem;
    img {
      width: 12px;
      height: 12px;
    }
  }

  @media (max-width: 375px) {
    font-size: 0.6rem;
    img {
      width: 10px;
      height: 10px;
    }
  }`

export const PostWindowContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  z-index: 999;
`;

export const PostImageContainer = styled.div`
flex: 7;
max-width: 100%;
background: black;
display: flex;
justify-content: center;
align-items: center;
`;

export const PostImage = styled.img`
max-width: 100%;
max-height: 100%;
object-fit: contain;
`;

export const PostCommentsContainer = styled.div`
flex: 3;
background: #f9f9f9;
padding: 16px;
overflow-y: auto;
`;

export const PostInfo = styled.div`
margin-bottom: 16px;
border-bottom: 1px solid #ddd;
padding-bottom: 8px;
`;

export const CommentsFiltering = styled.div`
  font-size: 14px;
  color: gray;
  padding: 12px 12px;

`;

export const CommentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 12px 12px;
  gap: 12px;
`;

export const CommentContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;

  align-items: flex-start;
`;

export const CommentImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

export const CommentDetails = styled.div`
  flex: column;
  background-color: #F1F2F5;
  border-radius: 10px;
  padding: 10px;
`;

export const CommentContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CommentOwner = styled.span`
  font-weight: bold;
  font-size: 14px;
`;

export const CommentBottom = styled.div`
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: gray;
`;

export const WriteComment = styled.div`
  margin-top: auto;
  border-top: 1px solid #ddd;
  padding-top: 12px;
  display: flex;
  gap: 12px;
`;


export const CommentButton = styled.button`
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 30px;
  left: 30px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 10;
  display: flex;

  img {
    width: 18px;
    height: 18px;
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const CommentsPostActions = styled.div`
  
  border-bottom: 1.5px solid lightgray;
  display: flex;
  width: 95%;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;
  margin-right: auto;

`;

export const CommentContentWrapper = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
`;

export const CommentFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: gray;
`;


export const RightFooter = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  span {
    color: #606770;
  }
`;

export const LikeButton = styled.button`
  background: none;
  border: none;
  color: #606770;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    color: #FE2F67;
  }
`;

export const ReplyButton = styled.button`
  background: none;
  border: none;
  color: #606770;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    color: #FE2F67;
  }
`;

export const ToggleRepliesButton = styled.button`
  display: flex;
  flex-direction: column;
  background: none;
  border: none;
  color: #606770;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const ConnectorLine = styled.div`
  display: flex;
  align-items: center;
  margin-left: 30px;
  margin-top: -10px;

  .vertical-line {
    width: 2px;
    height: 20px;
    background-color: #ccc;
    margin-right: 8px;
  }
`;

export const ReplyContainer = styled(CommentContainer)`
  margin-left: 40px;
`;

export const WriteCommentContainer = styled(CommentContainer)`
  margin-top: 10px;
`;

export const CommentInput = styled.input`
  flex-grow: 1;
  padding: 10px;
  border-radius: 10px;
  border: none;
  font-size: 14px;
  background-color: #f1f2f5;

  &:focus {
    outline: none;
    border-color: #606770;
  }
`;